import React from "react";
import { useNavigate } from "react-router-dom";
import * as PR from "../../prime-modules/index";
import AdminFooter from "../layout/admin-footer";
import AdminHeader from "../layout/admin-header";
import "../dashboard/Dashboard.scss";
import SupersetChart from "./SupersetChart";

const Dashboard2 = () => {
 const navigate = useNavigate();

  const items = [
    {
      label: "Dashboard",
      command: () => {
        navigate("/dashboard");
      },
    },
  ];

  const home = { icon: "pi pi-home", url: "/" };

  return (
    <>
      <div className="main">
        <div className="layout-sidebar">
          <AdminHeader />
        </div>
        <div className="layout-content-wrapper relative">
          <section className="admin-users-section">
            <div className="grid grid-nogutter align-items-center">
              <div className="col-12">
                <div className="heading-sec flex align-items-center justify-content-between">
                  <div>
                    <div className="flex align-items-center">
                      <div className="card flex align-items-center">
                        <h1>Dashboard</h1>
                      </div>
                      <div className="breadcrumb-section">
                        <PR.BreadCrumb model={items} home={home} />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <div className="dashboard_section dashboard2-section">
              <div className="grid mt-1">
                <div className="col-12">
                  <div className="card">
                    <div className="p-6 border-round-lg graph-block-bg">
                      <div className="block-main">
                        <SupersetChart
                          height="800px"
                          config={{
                            hideTitle: false,
                            hideChartControls: false,
                            filters: {
                              expanded: true,
                            },
                          }}
                        />
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </section>
          <AdminFooter />
        </div>
      </div>
    </>
  );
};

export default Dashboard2;
